import { render, staticRenderFns } from "./login_type.vue?vue&type=template&id=f32183e6&scoped=true&"
import script from "./login_type.vue?vue&type=script&lang=js&"
export * from "./login_type.vue?vue&type=script&lang=js&"
import style0 from "./login_type.vue?vue&type=style&index=0&id=f32183e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32183e6",
  null
  
)

export default component.exports